import { Flame } from "lucide-react";

/**
 * HotBadge — selo animado "MAIS TOCADAS DA SEMANA" para os top 5 CDs/conteúdos.
 *
 * Props:
 *   rank?: number (1-5) → mostra o número do rank ("#1", "#2", etc) no badge
 *   compact?: boolean → versão pequena (só ícone + #N) pra mobile
 *   label?: string → texto customizado (default: "MAIS TOCADAS")
 *   position?: "tl" | "tr" | "bl" | "br" (default: "tl")
 */
export default function HotBadge({ rank, compact = false, label = "MAIS TOCADAS", position = "tl" }) {
  const posClass = {
    tl: "top-2 left-2",
    tr: "top-2 right-2",
    bl: "bottom-2 left-2",
    br: "bottom-2 right-2",
  }[position] || "top-2 left-2";

  return (
    <div className={`absolute ${posClass} z-20 pointer-events-none`}>
      <div className="relative">
        {/* Glow animado por trás */}
        <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-[#FF007F] rounded-full blur-md opacity-70 animate-pulse" />
        <div className="relative inline-flex items-center gap-1 bg-gradient-to-r from-amber-400 via-orange-500 to-[#FF007F] text-white px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full text-[10px] sm:text-[11px] font-black shadow-lg shadow-[#FF007F]/40 border border-white/20">
          <Flame size={compact ? 10 : 12} className="text-yellow-200 drop-shadow" fill="currentColor" />
          {rank ? <span className="tabular-nums">#{rank}</span> : null}
          {!compact && <span className="tracking-wider">{label}</span>}
        </div>
      </div>
    </div>
  );
}
